
<main class="bg-black text-white min-h-screen">

  <!-- Header Section -->
  <section class="pt-28 md:pt-32 pb-12 md:pb-16 px-4 sm:px-6 md:px-12 lg:px-16">
    <div class="max-w-6xl mx-auto">
      <app-navigate-back class="mb-4"></app-navigate-back>
      <h1 class="text-3xl sm:text-4xl md:text-5xl font-black mb-4 leading-tight">
        Beyond Tech, <span class="text-varroc-accent">Toward People</span>
      </h1>
      <p class="text-gray-400 text-base sm:text-lg max-w-2xl leading-relaxed">
        Our passionate leaders, steeped in automotive tech, guide a team that turns ideas into reality.
      </p>
    </div>
  </section>

  <!-- Cards Section -->
  <section class="relative pb-20 md:pb-28 px-4 sm:px-6 md:px-12 lg:px-16 overflow-hidden">
    <!-- Background blobs so backdrop-blur has something to blur through -->
    <div class="absolute top-0 left-1/4 w-72 sm:w-96 h-72 sm:h-96 bg-varroc-accent/20 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute bottom-0 right-1/4 w-64 sm:w-80 h-64 sm:h-80 bg-indigo-500/15 rounded-full blur-3xl pointer-events-none"></div>

    <div class="relative max-w-6xl mx-auto">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
        <div *ngFor="let leader of leaders"
          class="flex flex-col items-center gap-4 sm:gap-5 backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl px-5 sm:px-6 py-8 sm:py-10 min-h-full w-full shadow-2xl shadow-black/60 hover:bg-white/15 hover:border-white/30 transition-all duration-300">
          <!-- Photo -->
          <div class="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden ring-1 ring-white/30 flex-shrink-0">
            <img [src]="leader.img" [alt]="leader.name" class="w-full h-full object-cover">
          </div>
          <!-- Name -->
          <p class="text-white font-bold text-base text-center leading-tight min-h-[2.75rem] flex items-center">{{ leader.name }}</p>
          <!-- Role -->
          <p class="text-gray-400 text-sm text-center min-h-[2.5rem] flex items-center justify-center">{{ leader.role }}</p>
          <!-- LinkedIn -->
          <a [href]="leader.linkedin" target="_blank" rel="nofollow noopener noreferrer"
            class="inline-flex items-center justify-center w-11 h-11 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-[#0077b5] hover:bg-[#0077b5] hover:text-white hover:border-[#0077b5] transition-all">
            <i class='bx bxl-linkedin text-2xl leading-none block'></i>
          </a>
        </div>
      </div>
    </div>
  </section>

</main>